// Single pluggable scoring module. The real product ships a 3rd mode later,
// so every surface consumes computeScore()/scoreMeta() — never inline logic.

export const SCORING_MODES = {
  A: { id: "A", betterIsLower: true, labelKey: "common.goalsLost", nameKey: "demo.modeA" },
  B: { id: "B", betterIsLower: false, labelKey: "common.goalsCredited", nameKey: "demo.modeB" },
  C: { id: "C", betterIsLower: false, labelKey: "common.goalsVsCoach", nameKey: "demo.modeC" },
};

// core score for a single result
export function computeScore(mode, { lgd, actualGD, coachLGD }) {
  if (mode === "B") return actualGD - lgd;
  if (mode === "C") return (coachLGD ?? 0) - lgd; // goals better than the coach
  return lgd; // Mode A
}

export function scoreMeta(mode) {
  return SCORING_MODES[mode] || SCORING_MODES.A;
}

// season aggregate from a history array of {lgd, actualGD, coachLGD}
export function seasonScore(mode, history) {
  return history.reduce((sum, h) => sum + computeScore(mode, h), 0);
}

// cumulative series (for charts): array of running totals
export function cumulativeSeries(mode, history, key = "lgd") {
  let acc = 0;
  return history.map((h) => {
    const item = key === "lgd"
      ? computeScore(mode, h)
      : key === "coach"
        ? computeScore(mode, { lgd: h.coachLGD, actualGD: h.actualGD, coachLGD: h.coachLGD })
        : computeScore(mode, { lgd: h.aiLGD, actualGD: h.actualGD, coachLGD: h.coachLGD });
    acc += item;
    return Math.round(acc * 10000) / 10000;
  });
}

// comparator for leaderboard rows given active mode (returns sorted copy)
export function sortByScore(mode, rows, getScore) {
  const meta = scoreMeta(mode);
  return [...rows].sort((a, b) =>
    meta.betterIsLower ? getScore(a) - getScore(b) : getScore(b) - getScore(a)
  );
}
